import { render } from "./GameButton.vue?vue&type=template&id=f5041324&scoped=true"
import script from "./GameButton.vue?vue&type=script&lang=js"
export * from "./GameButton.vue?vue&type=script&lang=js"

import "./GameButton.vue?vue&type=style&index=0&id=f5041324&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5041324"]])

export default __exports__